import { CommitmentTypeEnum } from '@sola/schema/dotcom/cart/commitments.ts';
import type { GraphQLRecentTransaction } from '@sola/schema/dotcom/supporters/schema.generated.ts';

type TransactionFixtureConfig = {
  amount: number;
  beneficiaryGlobalId: string;
  cartId: string;
  commitmentId: string;
  completedAt: string;
  requestedAt: string;
  transactionId: string;
  step?: string | null;
  errorMessage?: string | null;
  additionalItems?: {
    amount: number;
    beneficiaryGlobalId: string;
    commitmentId: string;
  }[];
};

const createCommitmentTransaction = ({
  amount,
  beneficiaryGlobalId,
  commitmentId,
  completedAt,
  requestedAt,
  transactionId,
  cartId,
  step = null,
  errorMessage = null,
  additionalItems = [],
}: TransactionFixtureConfig): GraphQLRecentTransaction => ({
  status: step ? 'Unsuccessful' : 'Successful',
  transactionId,
  createdAt: requestedAt,
  completedAt,
  lastUpdatedAt: completedAt,
  original: {
    items: [
      {
        commitmentId,
        commitmentType: CommitmentTypeEnum.ChildSponsorship,
        currentRate: amount,
        fundCode: 'DS',
        frequency: 'Monthly',
        isRecurring: true,
        beneficiaryGlobalId,
      },
      ...additionalItems.map((item) => ({
        commitmentId: item.commitmentId,
        commitmentType: CommitmentTypeEnum.ChildSponsorship,
        currentRate: item.amount,
        fundCode: 'DS',
        frequency: 'Monthly',
        isRecurring: true,
        beneficiaryGlobalId: item.beneficiaryGlobalId,
      })),
    ],
    cartId,
    requestedAt,
  },
  error: {
    step,
    message: errorMessage,
  },
});

// TODO: Add non-commitment items to the mock transactions
export const MOCK_SUPPORTER_TRANSACTIONS: GraphQLRecentTransaction[] = [
  createCommitmentTransaction({
    transactionId: 'T-MOCK-SUCCESSFUL-MULTI',
    cartId: 'mock-successful-multi-beneficiary',
    amount: 38,
    beneficiaryGlobalId: '08314403',
    commitmentId: 'CN-11420555',
    requestedAt: '2026-05-26T08:01:22.377-05:00',
    completedAt: '2026-05-26T08:05:04.000Z',
    additionalItems: [
      {
        amount: 43,
        beneficiaryGlobalId: '08741919',
        commitmentId: 'CN-11543478',
      },
    ],
  }),
  createCommitmentTransaction({
    transactionId: 'T-178146139',
    cartId: 'HPDrImpIAJbzJIwSultSU6',
    amount: 43,
    beneficiaryGlobalId: '10347105',
    commitmentId: 'CN-20363889',
    requestedAt: '2026-05-24T08:01:22.377-05:00',
    completedAt: '2026-05-24T08:05:04.000Z',
  }),
  createCommitmentTransaction({
    transactionId: 'T-178146140',
    cartId: 'PvUbX_-M6_kGwTTpuwwAOQ',
    amount: 43,
    beneficiaryGlobalId: '10347105',
    commitmentId: 'CN-18961162',
    requestedAt: '2026-05-24T08:03:22.377-05:00',
    completedAt: '2026-05-24T08:05:04.000Z',
  }),
  createCommitmentTransaction({
    transactionId: 'T-178146163',
    cartId: 'wWth57A2LK3omCXDynUzVY',
    amount: 80,
    beneficiaryGlobalId: '11875262',
    commitmentId: 'CN-09078293',
    requestedAt: '2026-05-24T08:04:12.419-05:00',
    completedAt: '2026-05-24T08:35:31.000Z',
    step: 'Payment',
    errorMessage: 'Payment authorization failed',
    additionalItems: [
      {
        amount: 43,
        beneficiaryGlobalId: '08741919',
        commitmentId: 'CN-11543478',
      },
      {
        amount: 43,
        beneficiaryGlobalId: '08741919',
        commitmentId: 'CN-11543478',
      },
      {
        amount: 43,
        beneficiaryGlobalId: '08741919',
        commitmentId: 'CN-11543478',
      },
    ],
  }),
  createCommitmentTransaction({
    transactionId: 'T-178146164',
    cartId: 'PehjrigHlSCZwHz0HUAayx',
    amount: 80,
    beneficiaryGlobalId: '11875262',
    commitmentId: 'CN-21140084',
    requestedAt: '2026-05-24T08:04:12.419-05:00',
    completedAt: '2026-05-24T08:35:31.000Z',
    step: 'Commitment',
    errorMessage: 'Related Beneficiary Not Found!',
  }),
  createCommitmentTransaction({
    transactionId: 'T-178146165',
    cartId: 'Y7eq0pb-8W2PYouvLUF4RH',
    amount: 80,
    beneficiaryGlobalId: '11875262',
    commitmentId: 'CN-16184239',
    requestedAt: '2026-05-24T08:04:12.419-05:00',
    completedAt: '2026-05-25T08:35:31.000Z',
  }),
];
